import { useState } from 'react';
import {
  DndContext,
  closestCorners,
  DragOverlay
} from '@dnd-kit/core';
import KanbanColumn from './KanbanColumn';
import KanbanCard from './KanbanCard';
import api from '../../api/axios';

export default function KanbanBoard({ pipeline, onChange }) {
  const [activeLead, setActiveLead] = useState(null);

  /* =========================
     DRAG START
  ========================= */
  const handleDragStart = ({ active }) => {
    setActiveLead(active.data.current?.lead || null);
  };

  /* =========================
     DRAG END (MOVER LEAD)
  ========================= */
  const handleDragEnd = async ({ active, over }) => {
    setActiveLead(null);

    if (!over) return;

    const leadId = active.id;
    const nuevoPipelineId = over.id; // UUID (string)

    // evita update inútil
    if (
      active.data.current?.lead?.estado_pipeline === nuevoPipelineId
    ) {
      return;
    }

    try {
      await api.put(`/leads/${leadId}/pipeline`, {
        pipeline_id: nuevoPipelineId
      });

      onChange(); // recargar pipeline
    } catch (err) {
      console.error('❌ Error moviendo lead:', err);
      alert('Error moviendo lead');
    }
  };

  /* =========================
     PIPELINE ACTIONS
  ========================= */

  // RENOMBRAR
  const renombrarColumna = async (columnId, nombre) => {
    try {
      await api.put(`/pipeline/${columnId}`, { nombre });
      onChange();
    } catch (err) {
      console.error('❌ Error renombrando columna:', err);
      alert('Error renombrando columna');
    }
  };

  // ELIMINAR (SOFT DELETE)
  const eliminarColumna = async (columnId) => {
    try {
      await api.delete(`/pipeline/${columnId}`);
      onChange();
    } catch (err) {
      console.error('❌ Error eliminando columna:', err);
      alert('Error eliminando columna');
    }
  };

  // REORDENAR
  const moverColumna = async (columnId, direction) => {
    const index = pipeline.findIndex(
      c => c.pipeline_id === columnId
    );
    if (index === -1) return;

    const swapIndex =
      direction === 'left' ? index - 1 : index + 1;

    if (swapIndex < 0 || swapIndex >= pipeline.length) return;

    // generar nuevo orden
    const reordered = [...pipeline];
    [reordered[index], reordered[swapIndex]] =
      [reordered[swapIndex], reordered[index]];

    const payload = reordered.map((c, i) => ({
      id: c.pipeline_id,
      orden: i + 1
    }));

    try {
      // 👈 IMPORTANTE: PUT, no POST
      await api.put('/pipeline/reordenar', payload);
      onChange();
    } catch (err) {
      console.error('❌ Error reordenando columnas:', err);
      alert('Error reordenando columnas');
    }
  };

  return (
    <DndContext
      collisionDetection={closestCorners}
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
    >
      <div className="flex gap-6 overflow-x-auto pb-4">
        {pipeline.map(col => (
          <KanbanColumn
            key={col.pipeline_id}
            columnId={col.pipeline_id}
            title={col.nombre}
            leads={col.leads || []}
            onRename={renombrarColumna}
            onDelete={eliminarColumna}
            onMove={moverColumna}
          />
        ))}
      </div>

      {/* =========================
         DRAG OVERLAY
      ========================= */}
      <DragOverlay>
        {activeLead ? (
          <div className="w-72 pointer-events-none">
            <KanbanCard lead={activeLead} />
          </div>
        ) : null}
      </DragOverlay>
    </DndContext>
  );
}
